export default __webpack_public_path__ + "static/B0266-0190e2c33bbb72b6389b53f0346380cb.png";